<template>
    <Layout :is-subdomain="true">
        <div class="mx-auto max-w-7xl space-y-8 px-4 py-16 md:px-8">
            <div class="flex items-center justify-between">
                <div class="flex items-center space-x-8">
                    <img
                        v-if="company.logo?.length"
                        :src="company.logo"
                        alt=""
                        class="h-32 w-32 rounded-full bg-white object-contain p-4 shadow"
                    />

                    <div class="space-y-4">
                        <h1 class="text-4xl font-bold">{{ company.name }}</h1>

                        <div class="flex flex-wrap items-center gap-4">
                            <div v-if="company.city" class="badge">
                                <IconMapPin :size="16" />
                                <span>{{ company.city }}</span>
                            </div>

                            <div v-if="company.website_url" class="badge">
                                <IconWorld :size="16" />
                                <a :href="company.website_url" class="text-blue-500 underline" target="_blank" rel="noopener noreferrer">
                                    {{ company.website_url }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <InertiaLink v-if="showSpontaneous" href="/candidature-spontannee" class="button">
                    {{ $t('Spontaneous application') }}
                </InertiaLink>
            </div>

            <div class="prose prose-xl" v-html="company.description ?? ''"></div>

            <template v-if="hasOffers">
                <div class="flex items-center justify-between">
                    <p class="text-lg font-semibold underline">{{ $t('Latest offers at :name', { name: company.name }) }}</p>
                    <a :href="`${$page.props.appUrl}/emplois?entreprise=${company.slug}`" class="link">
                        {{ $t('View all offers') }} &rarr;
                    </a>
                </div>

                <div class="grid gap-8 lg:grid-cols-3">
                    <OfferCard v-for="offer in offers.data" :offer="offer" :is-subdomain="true" />
                </div>
            </template>

            <template v-if="hasFormations">
                <div class="flex items-center justify-between">
                    <p class="text-lg font-semibold underline">{{ $t('Latest formations at :name', { name: company.name }) }}</p>
                    <a :href="`${$page.props.appUrl}/formations?entreprise=${company.slug}`" class="link">
                        {{ $t('View all formations') }} &rarr;
                    </a>
                </div>

                <div class="grid gap-8 lg:grid-cols-3">
                    <FormationCard v-for="formation in formations.data" :formation="formation" :is-subdomain="true" />
                </div>
            </template>

            <template v-if="hasEvents">
                <div class="flex items-center justify-between">
                    <p class="text-lg font-semibold underline">{{ $t('Latest events at :name', { name: company.name }) }}</p>
                    <a :href="`${$page.props.appUrl}/evenements?entreprise=${company.slug}`" class="link">
                        {{ $t('View all events') }} &rarr;
                    </a>
                </div>

                <div class="grid gap-8 lg:grid-cols-3">
                    <EventCard v-for="event in events.data" :event="event" :is-subdomain="true" />
                </div>
            </template>
        </div>
    </Layout>
</template>

<script setup>
    import OfferCard from '@/Partials/OfferCard';
    import FormationCard from '@/Partials/FormationCard';
    import EventCard from '@/Partials/EventCard';

    import { computed, onMounted, ref } from 'vue';
    import { usePage } from '@inertiajs/inertia-vue3';
    import { Inertia } from '@inertiajs/inertia';
    import { IconMapPin, IconWorld } from '@tabler/icons-vue';

    const props = defineProps({
        company: Object,
        offers: Object,
        formations: Object,
        events: Object,
    });

    const page = ref(1);
    const query = ref('');

    const hasOffers = computed(() => {
        return Object.values(props.offers.data).length > 0;
    });

    const hasFormations = computed(() => {
        return Object.values(props.formations.data).length > 0;
    });

    const hasEvents = computed(() => {
        return Object.values(props.events.data).length > 0;
    });

    const showSpontaneous = computed(() => {
        return false;
        return props.company.name === 'Mil-Tech Ressources inc.';
    });

    onMounted(() => {
        let url = usePage().props.value.url;
        let params = new URLSearchParams(url.split('?')[1]);

        if (params.get('recherche')) {
            query.value = params.get('recherche');
        }
    });

    function search() {
        let data = {};
        if (query.value.length) {
            data.recherche = query.value;
        } else {
            data.recherche = '';
        }

        Inertia.visit(usePage().props.value.url, {
            data: data,
        });
    }

    function resetSearch() {
        query.value = '';
        search();
    }
</script>
